import React from "react";
import { } from "react-redux";
// import CountUp from 'react-countup';
import "./DashBoardNum.scss";


export default function DashBoardNum({ text, image, count, percentage, setnum }) {

  return (
    // <div className={role !== 3 ? "col-xl-3 col-md-6 mb-sm-2" : "col-xl-3 col-md-6 mb-sm-2"} >
    <div className="col-xl-3 col-md-6 mb-sm-2" >
      <div className="card dash-num-card h-100">
        <div className="card-body custom-card">
          <div className="float-left">
            <p>{text}</p>
            <div className="number">
              {count}
            </div>
          </div>

          <div className="float-right text-right">
            <i>
              <img src={image} alt="nodwin" className="img-fluid pt-1" />
            </i>
            <div className="rate-up1">{percentage}</div>
          </div>
        </div>
      </div>
    </ div>
  );
}
